import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={40}
    height={31}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={39} height={30} rx={4.5} fill={props.btncolorprops} />
    <path
      d="M21.28 15.23h2.05c.567 0 1.026.455 1.026 1.025 0 .566-.455 1.025-1.025 1.025h-3.076a1.022 1.022 0 0 1-1.025-1.015v-4.12c0-.562.455-1.016 1.025-1.016.566 0 1.025.462 1.025 1.016v3.085Zm-9.127-3.301a9.227 9.227 0 1 1-.296 5.69l1.98-.532a7.177 7.177 0 1 0 .12-4.116l2.321 1.34-4.951 1.326L10 10.686l2.153 1.243Z"
      fill="#fff"
    />
    <rect x={0.5} y={0.5} width={39} height={30} rx={4.5} stroke={props.btncolorprops} />
  </svg>
);

export default SvgComponent;
